export function trackVideoProgress(threshold, progressHandler, buttonCopy){
    const video = document.getElementById('gate-video');
    const buttonContainer = document.getElementById('buttonContainer');
    const timeRemainingElement = document.getElementById('timeRemaining');

    // display the connect button if enough time has elapsed in the video
    if (buttonContainer.innerHTML == ``){
        if(video.duration > 0 && (video.currentTime / video.duration) >= threshold) {
            buttonContainer.innerHTML = `<button type="button" class="btn btn-info btn-lg w-90" id="continue-btn">${buttonCopy}</button>`
        }
    }

    const timeToGo = video.duration * threshold;
    const timeLeft = Math.ceil(timeToGo - video.currentTime);
    if (timeLeft > 0){
        // update countdown text if video remains
        timeRemainingElement.innerHTML = `${timeLeft} seconds until Wi-Fi access`;
    }
    else {
        // remove the countdown text and stop this event listener if the user has seen enough video
        timeRemainingElement.innerHTML = ``;
        video.removeEventListener('timeupdate', progressHandler);
    }
}